import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DetailViewModule } from '@ui/shared/ui-detail-view';
import { EducationalFundingMeasureGroup } from '../../definitions/educational-funding-measure-group';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-school-map-item-measure-details',
    templateUrl: './school-map-item-measure-details.component.html',
    styleUrls: ['./school-map-item-measure-details.component.scss'],
    imports: [
        DetailViewModule,
    ],
})
export class SchoolMapItemMeasureDetailsComponent {
    @Input({ required: true })
    public measureGroup!: EducationalFundingMeasureGroup;
}
